import React from "react";
import { Link } from "react-router-dom";
import "w3-css/3/w3.css";

const Footer = () => {
  return (
    <footer className="w3-padding-32 w3-dark-gray w3-center w3-margin-top">
      <div className="w3-container">
        <div className="w3-row">
          <div className="w3-third">
            <h4 className="w3-text-orange">Kayannou</h4>
            <p className="w3-text-light-gray">Free unit conversion tools for everyone</p>
          </div>
          <div className="w3-third">
            <h4 className="w3-text-orange">Quick Links</h4>
            <p>
              <Link to="/conversion/area" className="w3-text-light-gray w3-hover-text-white">Area Converter</Link><br/>
              <Link to="/conversion/length" className="w3-text-light-gray w3-hover-text-white">Length Converter</Link><br/>
              <Link to="/conversion/temperature" className="w3-text-light-gray w3-hover-text-white">Temperature Converter</Link>
            </p>
          </div>
          <div className="w3-third">
            <h4 className="w3-text-orange">Legal</h4>
            <p>
              <Link to="/privacy-policy" className="w3-text-light-gray w3-hover-text-white">Privacy Policy</Link><br/>
              <Link to="/terms-of-service" className="w3-text-light-gray w3-hover-text-white">Terms of Service</Link><br/>
              <a href="mailto:contact@kayannou.com" className="w3-text-light-gray w3-hover-text-white">Contact Us</a>
            </p>
          </div>
        </div>
        <hr className="w3-border-orange w3-margin-top"/>
        <p className="w3-text-light-gray">
          © {new Date().getFullYear()} Kayannou. All rights reserved. |
          Powered by Kinanw
        </p>
        <p className="w3-text-light-gray w3-small">
          This website uses Google AdSense. By using this site, you agree to our use of cookies for advertising and analytics.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
